import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ── Sentry error tracking (#82) ──────────────────────────────────────────
if (process.env.REACT_APP_SENTRY_DSN_FRONTEND) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN_FRONTEND,
    environment: process.env.REACT_APP_ENV || 'production',
    // Tag every event with the deployed commit so Sentry can tie errors to a build.
    // Vercel exposes system env vars to CRA builds with the REACT_APP_ prefix.
    release: process.env.REACT_APP_VERCEL_GIT_COMMIT_SHA || undefined,
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.5,
  });
}

// ── Error boundary fallback ──────────────────────────────────────────────
function FallbackUI() {
  return (
    <div style={{ textAlign: 'center', padding: '60px 20px', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
      <h2 style={{ color: '#111827', marginBottom: '8px' }}>Something went wrong</h2>
      <p style={{ color: '#6B7280', marginBottom: '20px' }}>We've been notified and are looking into it.</p>
      <button
        onClick={() => window.location.reload()}
        style={{
          padding: '10px 24px',
          background: '#1F4E79',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          fontSize: '14px',
          fontWeight: 600,
          cursor: 'pointer',
        }}
      >
        Refresh Page
      </button>
    </div>
  );
}

const AppWithErrorBoundary = Sentry.withErrorBoundary(App, {
  fallback: FallbackUI,
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppWithErrorBoundary />
  </React.StrictMode>
);

reportWebVitals();
